/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared quickview snippet. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
/* Čapkov redesign: jednotný vzor posuvníků = ukazatel pokroku + kulaté šipky POD řadou (jako domovská Nejprodávanější), nikdy přes karty.
   Šablonové posuvníky, které už mají vlastní ukazatel (.scrollbar), zůstávají beze změny. Tady se vzor doplní tam, kde chyběl nebo kde šipky plavaly přes karty:
   PDP doporučení ([data-rr-track]), „Hodí se k tomu“ (.rd-comp), hledání „Oblíbené“ (.rds-row), šablonové scroll-carousel s plovoucími šipkami.
   Šipky: kruhy s obrysem, na začátku/konci vypnuté (průhledné), když se vše vejde, celé schované; na dotykových/úzkých displejích schované (swipe + nakukující karta).
   Okraje: měkké vyblednutí přes CSS mask (třídy rd-sl-fl / rd-sl-fr hlídá tento soubor). */
(function () {
  'use strict';
  if (window.__rdSlNav) return; window.__rdSlNav = 1;
  var CS = /^(cs|sk)/i.test(document.documentElement.lang || 'cs');
  var L = { prev: CS ? rdOT("previous_50f9428", "Previous") : rdOT("previous_50f9428", "Previous"), next: CS ? rdOT("next_bc98198", "Next") : rdOT("next_bc98198", "Next") };
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion:reduce)') : { matches: false };
  var SEL = '[data-rr-track],scroll-carousel,.rds-row';
  var ITEMS = 'product-card,.image-link-blocks__item,.rdr__card,.rd-hpair,.rd-compi,.rr-card,.rd-rev,.rds-card,.rd-insp2__i';
  function items(el) { return [].filter.call(el.querySelectorAll(ITEMS), function (i) { return i.offsetParent !== null; }); }
  function go(el, dir) {
    var it = items(el), cs = getComputedStyle(el);
    var step = it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : (it[0] ? it[0].offsetWidth : el.clientWidth);
    var avail = el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var amount = Math.max(step, avail - Math.min(48, step * 0.2));
    var max = el.scrollWidth - el.clientWidth;
    el.scrollTo({ left: Math.max(0, Math.min(max, el.scrollLeft + dir * amount)), behavior: RM.matches ? 'auto' : 'smooth' });
  }
  function svg(d) { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; }
  /* kam patří lišta: za obal řady; null = posuvník má vlastní ukazatel / nic nepotřebuje */
  function place(tr) {
    var bl = tr.closest('.rds-block'); if (bl) return { after: tr };
    if (tr.hasAttribute('data-rr-track')) return { after: tr.closest('.rr-car') || tr };
    var c = tr.closest('.scrollable-with-controls,.floating-controls-container');
    if (c && !c.querySelector('.scrollbar') && c.querySelector('[aria-controls="' + tr.id + '"]')) return { after: c, native: true };
    return null;
  }
  function adopt(tr) {
    if (tr.__rdSlN) return; tr.__rdSlN = 1;
    if (tr.closest('#cart-drawer,cart-drawer,.horizontal-product-list-carousel')) return;
    var pl = place(tr), bar = null, p = null, n = null, fill = null;
    if (pl && pl.after && pl.after.parentNode) {
      bar = pl.after.nextElementSibling && pl.after.nextElementSibling.classList.contains('rd-sl-bar') ? pl.after.nextElementSibling : null;
      if (!bar) { bar = document.createElement('div'); bar.className = 'rd-sl-bar'; pl.after.parentNode.insertBefore(bar, pl.after.nextSibling); }
      bar.className = 'rd-sl-bar'; bar.innerHTML = '<div class="rd-sl-prog" aria-hidden="true"><i></i></div><div class="rd-sl-btns"><button type="button" class="rd-sl-btn" aria-label="' + L.prev + '">' + svg('M15 5l-7 7 7 7') + '</button><button type="button" class="rd-sl-btn" aria-label="' + L.next + '">' + svg('M9 5l7 7-7 7') + '</button></div>';
      var b = bar.querySelectorAll('.rd-sl-btn'); p = b[0]; n = b[1]; fill = bar.querySelector('i');
      if (tr.id) { p.setAttribute('aria-controls', tr.id); n.setAttribute('aria-controls', tr.id); }
      if (pl.native) [].forEach.call(document.querySelectorAll('[aria-controls="' + tr.id + '"]'), function (c) { if (!bar.contains(c)) c.classList.add('rd-sl-gone'); });
      p.addEventListener('click', function () { go(tr, -1); }); n.addEventListener('click', function () { go(tr, 1); });
    }
    var raf = 0;
    function upd() {
      var sw = tr.scrollWidth, cw = tr.clientWidth, max = sw - cw, x = Math.abs(tr.scrollLeft), fit = max <= 3;
      if (bar) {
        p.disabled = x <= 2; n.disabled = x >= max - 2; bar.classList.toggle('is-fit', fit); bar.setAttribute('aria-hidden', fit ? 'true' : 'false');
        if (!fit) { var r = Math.min(1, cw / sw); fill.style.width = (r * 100).toFixed(2) + '%'; fill.style.left = (max > 0 ? (x / max) * (1 - r) * 100 : 0).toFixed(2) + '%'; }
      }
      tr.classList.add('rd-sl-on'); tr.classList.toggle('rd-sl-fl', !fit && x > 2); tr.classList.toggle('rd-sl-fr', !fit && x < max - 2);
    }
    function sched() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; upd(); }); }
    tr.addEventListener('scroll', sched, { passive: true });
    if (window.ResizeObserver) { var ro = new ResizeObserver(sched); ro.observe(tr); if (tr.firstElementChild) ro.observe(tr.firstElementChild); }
    if (window.MutationObserver) new MutationObserver(sched).observe(tr, { childList: true, subtree: true });
    window.addEventListener('resize', sched); window.addEventListener('load', sched, { once: true });
    if (bar && !tr.hasAttribute('data-rd-slider')) {
      tr.addEventListener('keydown', function (e) {
        if (e.target !== tr || e.altKey || e.ctrlKey || e.metaKey) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(tr, 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(tr, -1); }
      });
      if (!tr.hasAttribute('tabindex')) tr.tabIndex = 0;
      if (!tr.hasAttribute('role')) { tr.setAttribute('role', 'group'); tr.setAttribute('aria-roledescription', 'carousel'); }
      if (!tr.hasAttribute('aria-label')) { var s = tr.closest('[data-rr-row],section,.shopify-section,.rds-block'), t = s && s.querySelector('h2,.rr-h,.rds-h'); if (t) tr.setAttribute('aria-label', t.textContent.trim()); }
    }
    upd(); setTimeout(upd, 400);
  }
  var q = 0;
  function scan() { q = 0; [].forEach.call(document.querySelectorAll(SEL), adopt); }
  function sch() { if (!q) q = requestAnimationFrame(scan); }
  if (window.MutationObserver) new MutationObserver(sch).observe(document.documentElement, { childList: true, subtree: true });
  ['rd:lazy-loaded', 'shopify:section:load'].forEach(function (e) { document.addEventListener(e, sch); });
  window.addEventListener('load', sch);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sch, { once: true }); else sch();
})();

})();
